import React, { useState } from "react";
import Input from "./Input";
import FileBase from "react-file-base64";
import { useDispatch, useSelector } from "react-redux";

import axios from "axios";
import Content from "./Content";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.css";
import { newProduct, setNewEditedProduct } from "../../actions/storeActions";

const CreateProductModal = () => {
  const dispatch = useDispatch();

  const productDetail = useSelector((state) => state.productDetail);

  const [categoryType, setCategoryType] = useState({
    category: productDetail ? productDetail.category : "dish",
    type: productDetail ? productDetail.type : "Medicine",
    reserved: productDetail ? productDetail.reservation : false,
  });

  const [formData, setFormData] = useState(productDetail);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [blob, setBlob] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let data = new FormData();

    data.append("name", formData.name);
    data.append("thumbnail", formData.thumbnail);
    data.append("price", formData.price);
    data.append("discount", formData.discount);
    data.append("points", formData.points);
    data.append("description", JSON.stringify(formData.description));
    data.append("type", categoryType.type);
    data.append("category", categoryType.category);
    data.append("pieces", formData.pieces);
    data.append("reservation", categoryType.reserved);
    data.append("_id", formData._id);
    data.append("idx", formData.idx);
    data.append("sold", formData.sold);

    // const dataObject = {
    //   name: formData.name,

    //   price: formData.price,
    //   discount: formData.discount,
    //   points: formData.points,
    //   description: formData.description,
    //   type: categoryType.type,
    //   category: categoryType.category,
    //   pieces: formData.pieces,
    //   reservation: categoryType.reserved,
    //   _id: formData._id,
    //   idx: formData.idx,
    //   sold: formData.sold,
    // };

    if (productDetail.edit) {
      // dispatch({
      //   type: "EDIT_SELECTED_DATA",
      //   payload: {
      //     dataObject,
      //     discount:
      //       data.discount >= 1 && data.discount < 100
      //         ? data.discount / 100
      //         : data.discount,
      //   },
      // });
      const response = await setNewEditedProduct(data);

      if (response.param === "success") {
        setLoading(false);
        alertify.set("notifier", "position", "bottom-right");
        alertify.success(`${response.msg}`);
      }
    } else {
      // dispatch({
      //   type: "ADD_TO_TABLE_DATA",
      //   payload: { data: dataObject, category: data.category },
      // });
      // setTableData({
      //   ...table_data.table_data,
      //   [`${data.category}`]: [...table_data.table_data[`${data.category}`]],
      // });

      const response = await newProduct(data);
      if (response.param === "success") {
        setFormData({
          name: "",
          price: "",
          discount: "",
          points: "",
          description: [],
          type: "",
          category: "",
          pieces: "",
        });
        setLoading(false);
        alertify.set("notifier", "position", "bottom-right");
        alertify.success(`${response.msg}`);
      }
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleImage = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
    // fetch(base64)
    //   .then((res) => res.blob())
    //   .then(console.log);
  };
  return (
    <>
      <div className="create-article-container ">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <h3>Product</h3>
          <Input
            type="number"
            handleChange={handleChange}
            value={formData.pieces}
            name="pieces"
            id="pieces"
            autoComplete="off"
            placeholder={error && error.name}
            direction="column"
            errorHandler="true"
          />
          <Input
            type="text"
            handleChange={handleChange}
            value={formData.name}
            name="name"
            id="name"
            autoComplete="off"
            placeholder={error && error.title}
            direction="column"
            errorHandler="true"
          />
          <Input
            type="number"
            handleChange={handleChange}
            value={formData.price}
            name="price"
            id="price"
            autoComplete="off"
            placeholder={error && error.summary}
            direction="column"
            errorHandler="true"
          />
          <Input
            type="text"
            handleChange={handleChange}
            value={formData.points}
            name="points"
            id="points"
            autoComplete="off"
            placeholder={error && error.summary}
            direction="column"
            errorHandler="true"
          />
          <Input
            type="text"
            handleChange={handleChange}
            value={formData.discount}
            name="discount"
            id="discount"
            autoComplete="off"
            placeholder={error && error.summary}
            direction="column"
            errorHandler="true"
          />
          <h3 className="header_title">Category</h3>
          <select
            name="category"
            id="category"
            onChange={(e) =>
              setCategoryType({ ...categoryType, category: e.target.value })
            }
          >
            <option selected={productDetail?.category === "dish"} value="dish">
              Dish
            </option>
            <option
              selected={productDetail?.category === "goods"}
              value="goods"
            >
              Goods
            </option>
          </select>
          <h3 className="header_title">Type</h3>
          <select
            name="type"
            id="type"
            onClick={() => console.log("clicked")}
            onChange={(e) =>
              setCategoryType({ ...categoryType, type: e.target.value })
            }
          >
            <option
              selected={productDetail?.type === "Medicine"}
              value="Medicine"
            >
              Medicine
            </option>
            <option selected={productDetail?.type === "Dish"} value="Dish">
              Dish
            </option>
            <option selected={productDetail?.type === "Toys"} value="Toys">
              Toys
            </option>
          </select>
          <h3 className="header_title">Reservation</h3>
          <select
            name="type"
            id="type"
            onChange={(e) =>
              setCategoryType({ ...categoryType, reserved: e.target.value })
            }
          >
            <option selected={productDetail?.reservation} value={false}>
              Closed
            </option>
            <option selected={productDetail?.reservation} value={true}>
              Open
            </option>
          </select>
          <Content
            formData={formData}
            setFormData={setFormData}
            loading={loading}
          />
          <div className="thumbnail-container">
            <label htmlFor="thumbnail">Thumbnail</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImage(e)}
              name="thumbnail"
              id="thumbnail"
            />
            {error && <p style={{ color: "red" }}>{error.thumbnail}</p>}
          </div>

          {formData.description?.length > 0 && (
            <button disabled={loading} type="submit">
              {loading
                ? productDetail.edit
                  ? "Editing new product"
                  : "Adding new product..."
                : productDetail.edit
                ? "Edit Product"
                : "Add Product"}
            </button>
          )}
        </form>
      </div>
    </>
  );
};

export default CreateProductModal;
